/**
 * 다른 모듈로 넘어가는 링크에 ?_from= 을 실어, 도착 페이지 상단의
 * back-link 파셜(← 출처)이 돌아갈 곳을 알 수 있게 한다.
 *
 * 파라미터 이름이 "from"이 아니라 "_from"인 이유: 일부 화이트리스트 대상
 * 경로(예: /hr/insights의 날짜 범위 from, /erp/docs/:kind/new의 상위 문서
 * 프리필 from)는 이미 "from"을 다른 용도로 쓰고 있어, 그대로 얹으면
 * 충돌한다.
 *
 * 여기서 고르는 후보는 참고일 뿐 신뢰 경계가 아니다 — 실제 화이트리스트
 * 검증과 라벨 결정은 서버(server/back_link.go, backLinkFrom)가 한다.
 */

// '/admin/approval/' (2026-09-18): the two approval admin pages live under the
// administrator sidebar, so a hop from /approval/* carries where it came from.
const CROSS_MODULE_PREFIXES = ['/crm/', '/erp', '/work', '/approval/', '/admin/approval/', '/hr', '/attendance', '/calendar', '/directory', '/dashboard'];

function firstSegment(pathname) {
    return pathname.split('/').filter(Boolean)[0] || '';
}

export function setupBackLink() {
    if (document.__backLinkBound) return;
    document.__backLinkBound = true;

    document.addEventListener('click', (e) => {
        if (e.defaultPrevented || e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const a = e.target.closest('a[href]');
        if (!a) return;
        if (a.target || a.hasAttribute('download') || a.hasAttribute('data-no-back')) return;

        let url;
        try { url = new URL(a.href, location.href); } catch (err) { return; }
        if (url.origin !== location.origin) return;
        if (!CROSS_MODULE_PREFIXES.some((prefix) => url.pathname.startsWith(prefix))) return;
        if (firstSegment(url.pathname) === firstSegment(location.pathname)) return;
        if (url.searchParams.has('_from')) return;

        // Strip any _from= already on the current page before embedding it,
        // so hopping module -> module -> module doesn't nest the value
        // (each hop would otherwise roughly double it until the 300-byte
        // cap in back_link.go silently drops the link).
        const here = new URL(location.href);
        here.searchParams.delete('_from');
        url.searchParams.set('_from', here.pathname + here.search);
        a.href = url.pathname + url.search + url.hash;
    });

    // The back-link partial isn't an SPA root or a [data-spa-region] (it
    // sits in plain .container markup), so an in-section pjax navigation
    // (a filter chip, a saved view, a sort/column change — none of which
    // carry ?_from= forward) leaves the rendered "← 출처" link on screen
    // pointing at a page the address bar has already left behind.
    // calendar-spa.js's navigate() dispatches calendar:navigated after
    // every such update (same-section or not) with the URL already
    // updated, so drop the stale link once ?_from= is no longer part of it.
    document.addEventListener('calendar:navigated', () => {
        if (new URL(location.href).searchParams.has('_from')) return;
        const el = document.querySelector('.back-link');
        if (el) el.remove();
    });
}
